<div [ngStyle]="style">
  @if (InlineActionsCount > 0) {
    @if (dropdownIcon) {
      <button
        id="dropdown-btn"
        mat-icon-button
        type="button"
        [matMenuTriggerFor]="actionMenu"
        (click)="onClickDropdownButton($event)"
        (menuOpened)="menuOpened()"
        class="d-flex justify-content-center"
      >
        <i-tabler [name]="dropdownIcon" class="icon-20 d-flex"></i-tabler>
      </button>
      <mat-menu
        #actionMenu="matMenu"
        [class]="isModernLayout ? 'modern-inline-action-menu' : 'cardWithShadow p-0'"
      >
        @for (inlineAction of inlineActions; track inlineAction.name) {
          @if (!inlineAction.hidden?.()) {
            <button
              mat-menu-item
              type="button"
              [ngClass]="[
                class ?? '',
                isModernLayout ? 'modern-inline-action-item' : ''
              ]"
              [disabled]="getDisable(inlineAction)"
              (click)="inlineAction?.action(row)"
              [ngStyle]="inlineAction?.style"
            >
              <div class="d-flex align-items-center">
                <i-tabler [name]="inlineAction.icon ?? ''" class="modern-inline-action-icon icon-18 m-r-6"></i-tabler>
                {{ inlineAction.name | translate }}
              </div>
            </button>
          }
        }
      </mat-menu>
    } @else {
      @for (inlineAction of inlineActions; track inlineAction.name) {
        <a
          matTooltip="{{ inlineAction.name | translate }}"
          matTooltipPosition="above"
          (click)="!inlineAction.disabled && inlineAction.action(row)"
          class="m-r-10 cursor-pointer"
          [ngStyle]="inlineAction.style"
        >
          <i-tabler [name]="inlineAction.icon ?? ''" class="icon-18" />
        </a>
      }
    }
  }
</div>
